import React, { useState } from 'react';
import Axios from 'axios';
import { useLoadout } from '../context/LoadoutContext';
import { useUnlocks } from '../context/UnlocksContext';
import { useUser } from '../context/UserContext';
import { updateUnlockList, updateUserCredits } from '../services/armoryCalls';
import ArmoryLowBalanceModal from './ArmoryLowBalanceModal';

export default function ArmoryGearCard(props) {
  const [showModal, setShowModal] = useState(false);
  const [modalDet, setModalDet] = useState({
    modalDet: {
      title: '',
      msg: '',
      color: '',
    },
  });
  // const [modalMsg, setModalMsg] = useState();
  // const [modalTitle, setModalMsg] = useState();
  const loadoutCon = useLoadout();
  const unlocks = useUnlocks();
  const user = useUser();

  const handleChangeItem = e => {
    const clickedItem = {
      Key: loadoutCon.loadoutItemKey,
      Cat: e.target.dataset.cat,
      SKU: e.target.dataset.sku,
      Type: e.target.dataset.type,
      URL1: e.target.dataset.icon1,
      URL2: e.target.dataset.icon2,
      uName: e.target.dataset.name,
    };

    loadoutCon.setUpdateOneItem(loadoutCon.loadoutItemKey, clickedItem);
  };

  const unlockItem = async () => {
    let value = 1;
    let objName = `U${props.lvl}`;
    // console.log(objName, value);

    Axios.get(`${process.env.REACT_APP_API_URL}/checkcredits`, {
      params: {
        ID: user.steamID,
      },
    })
      .then(res => {
        user.setUpdatedCredit(res.data[0].Credit);
        let tempBalance = res.data[0].Credit;

        if (props.cost > 0) {
          let newBalance = tempBalance - props.cost;
          if (newBalance < 0) {
            setModalDet({
              modalDet: {
                title: 'Test',
                msg: 'Hey his worked',
                color: 'red-800',
              },
            });

            setShowModal(true);
            // return <ArmoryLowBalanceModal />;
          } else {
            // updates unlocks context
            unlocks.setUpdateOneItem(objName, value);
            // Updates the DB
            updateUnlockList(user.steamID, objName, value);
            // Updates Credits in the Context
            user.setUpdatedCredit(newBalance);
            // Updates Credits in the DB
            updateUserCredits(user.steamID, newBalance);
          }
        }
      })
      .catch(err => console.log(err));
  };

  const computeBothMode = playersLockType => {
    if (playersLockType === 0) {
      return (
        <div className='h-8 flex justify-between items-center'>
          <p className='uppercase text-gray-300 text-sm pl-1'>
            Req LVL: {props.lvl}
          </p>
          <p className='bg-illOrange-500 p-1 text-gray-100 tracking-wide uppercase cursor-not-allowed flex justify-center items-center'>
            <svg
              xmlns='http://www.w3.org/2000/svg'
              className='h-5 w-5 mr-1'
              fill='none'
              viewBox='0 0 24 24'
              stroke='currentColor'
            >
              <path
                strokeLinecap='round'
                strokeLinejoin='round'
                strokeWidth={2}
                d='M12 15v2m-6 4h12a2 2 0 002-2v-6a2 2 0 00-2-2H6a2 2 0 00-2 2v6a2 2 0 002 2zm10-10V7a4 4 0 00-8 0v4h8z'
              />
            </svg>
            Locked
          </p>
        </div>
      );
    }
    if (playersLockType === 2) {
      return (
        <div className='h-8 flex justify-between items-center'>
          <p className='uppercase text-gray-300 text-sm pl-1'>
            Cost: {props.cost} WB
          </p>
          <p
            href='#'
            className='bg-illOrange-500 text-white p-1 font-bold tracking-wide uppercase cursor-pointer hover:bg-illOrange-400 transition ease-in'
            onClick={unlockItem}
          >
            Buy Now
          </p>
        </div>
      );
    }
  };

  // Changes the background to the second Icon after interval length
  const changeImg = e => {
    let icon1 = props.icon1;
    let icon2 = props.icon2;
    // let icon1 = e.target.dataset.icon1;
    // let icon2 = e.target.dataset.icon2;
    if (icon2 === '') {
      icon2 += icon1;
    }
    e.target.src = icon2;
    // setInterval(() => {
    //   e.target.src = icon2;
    // }, 2000);

    // setTimeout(() => {
    //   e.target.src = icon2;
    // }, 2000);
  };

  // Resets the image back to icon 1
  const resetImg = e => {
    // let icon1 = e.target.dataset.icon1;
    let icon1 = props.icon1;
    e.target.src = icon1;
    // setInterval(() => {
    //   e.target.src = icon1;
    // }, 2000);
  };

  const returnNull = () => {
    return null;
  };

  const displayCard = () => {
    let unlockQuery = `U${props.lvl}`;
    if (unlocks[unlockQuery] === 0 && props.lock === 'Rank') {
      return (
        <div className='max-w-sm bg-gray-800 rounded-sm border border-gray-800 shadow-sm'>
          {/* {showModal ? <ArmoryLowBalanceModal /> : null} */}
          {/* <div className='bg-gray-900 opacity-100 h-full z-0 '> */}
          <p className='text-gray-400 text-left font-bold p-1 text-sm sm:text-sm'>
            {props.name}
          </p>
          <div className='group bg-gray-900'>
            <img
              src={props.icon1}
              alt={`${props.name} icon`}
              title={props.name}
              className='w-24 h-20 mx-auto cursor-not-allowed '
              data-name={props.name}
              data-sku={props.sku}
              data-icon1={props.icon1}
              data-icon2={props.icon2}
              data-cat={props.cat}
              data-type={props.type}
              onMouseOver={changeImg}
              onMouseLeave={resetImg}
            />
          </div>

          <div className='h-8 flex justify-between items-center'>
            <p className='uppercase text-gray-300 text-sm pl-1'>
              Req LVL: {props.lvl}
            </p>
            <p className='bg-illOrange-500 p-1 text-gray-100 uppercase cursor-not-allowed flex justify-center items-center sm:tracking-tight md:tracking-normal lg:tracking-wide'>
              <svg
                xmlns='http://www.w3.org/2000/svg'
                className='h-5 w-5 mr-1'
                fill='none'
                viewBox='0 0 24 24'
                stroke='currentColor'
              >
                <path
                  strokeLinecap='round'
                  strokeLinejoin='round'
                  strokeWidth={2}
                  d='M12 15v2m-6 4h12a2 2 0 002-2v-6a2 2 0 00-2-2H6a2 2 0 00-2 2v6a2 2 0 002 2zm10-10V7a4 4 0 00-8 0v4h8z'
                />
              </svg>
              Locked
            </p>
          </div>
        </div>
      );
    }
    if (unlocks[unlockQuery] === 0 && props.lock === 'Game') {
      // Checks if the gun has a ParID1 (level of parent unlock before letting it buyable)
      if (props.parID1 !== 0 && unlocks[`U${props.parID1}`] === 0) {
        return (
          <div className='max-w-sm bg-gray-800 rounded-sm border border-gray-800 shadow-sm'>
            {/* <div className='bg-gray-900 opacity-100 h-full z-0 '> */}
            <p className='text-gray-400 text-left font-bold p-1 text-sm sm:text-sm'>
              {props.name}
            </p>
            <div className='group bg-gray-900'>
              <img
                src={props.icon1}
                alt={`${props.name} icon`}
                title={props.name}
                className='w-24 h-20 mx-auto cursor-not-allowed '
                data-name={props.name}
                data-sku={props.sku}
                data-icon1={props.icon1}
                data-icon2={props.icon2}
                data-cat={props.cat}
                data-type={props.type}
                onMouseOver={changeImg}
                onMouseLeave={resetImg}
              />
            </div>

            <div className='h-8 flex justify-between items-center'>
              <p className='uppercase text-gray-300 text-sm pl-1'>
                Req LVL: {props.parID1}
              </p>
              <p className='bg-illOrange-600 p-1 text-gray-100 uppercase cursor-not-allowed flex justify-center items-center sm:tracking-tight md:tracking-normal lg:tracking-wide'>
                <svg
                  xmlns='http://www.w3.org/2000/svg'
                  className='h-5 w-5 mr-1'
                  fill='none'
                  viewBox='0 0 24 24'
                  stroke='currentColor'
                >
                  <path
                    strokeLinecap='round'
                    strokeLinejoin='round'
                    strokeWidth={2}
                    d='M12 15v2m-6 4h12a2 2 0 002-2v-6a2 2 0 00-2-2H6a2 2 0 00-2 2v6a2 2 0 002 2zm10-10V7a4 4 0 00-8 0v4h8z'
                  />
                </svg>
                Locked
              </p>
            </div>
          </div>
        );
      } else {
        return (
          <div className='max-w-sm bg-gray-800 rounded-sm border border-gray-800 shadow-sm'>
            {showModal ? (
              <ArmoryLowBalanceModal stateChanger={setShowModal} />
            ) : (
              returnNull()
            )}

            {/* <div className='bg-gray-900 opacity-100 h-full z-0 '> */}
            <p className='text-gray-400 text-left font-bold p-1 text-sm'>
              {props.name}
            </p>
            <div className='group bg-gray-900'>
              <img
                src={props.icon1}
                alt={`${props.name} icon`}
                title={props.name}
                className='w-24 h-20 mx-auto cursor-not-allowed'
                data-name={props.name}
                data-sku={props.sku}
                data-icon1={props.icon1}
                data-icon2={props.icon2}
                data-cat={props.cat}
                data-type={props.type}
                onMouseOver={changeImg}
                onMouseLeave={resetImg}
              />
            </div>

            <div className='h-8 flex justify-between items-center'>
              <p className='uppercase text-gray-300 text-sm pl-1'>
                Cost: {props.cost} WB
              </p>
              <p
                href='#'
                className='bg-green-700 text-white py-1 px-4 tracking-wide uppercase cursor-pointer hover:bg-green-600 transition ease-in'
                onClick={unlockItem}
              >
                Buy
              </p>
            </div>
          </div>
        );
      }
    }
    // Checks for when an item costs warbonds and is unlocked via
    if (
      (unlocks[unlockQuery] === 0 && props.lock === 'Both') ||
      (unlocks[unlockQuery] === 2 && props.lock === 'Both')
    ) {
      return (
        <div className='max-w-sm bg-gray-800 rounded-sm border border-gray-800 shadow-sm'>
          {/* {showModal ? <ArmoryLowBalanceModal /> : null} */}

          {/* {showModal && (
            <ArmoryLowBalanceModal
              title={modalDet.title}
              msg={modalDet.msg}
              color={modalDet.color}
            />
          )} */}
          {showModal ? (
            <ArmoryLowBalanceModal stateChanger={setShowModal} />
          ) : (
            returnNull()
          )}

          {/* <div className='bg-gray-900 opacity-100 h-full z-0 '> */}
          <p className='text-gray-400 text-left font-bold p-1 text-sm'>
            {props.name}
          </p>
          <div className='group bg-gray-900'>
            <img
              src={props.icon1}
              alt={`${props.name} icon`}
              title={props.name}
              className='w-24 h-20 mx-auto cursor-not-allowed'
              data-name={props.name}
              data-sku={props.sku}
              data-icon1={props.icon1}
              data-icon2={props.icon2}
              data-cat={props.cat}
              data-type={props.type}
              onMouseOver={changeImg}
              onMouseLeave={resetImg}
            />
          </div>

          {computeBothMode(unlocks[unlockQuery], props.lvl, props.cost)}
        </div>
      );
    }
    // Real world Shop items
    if (unlocks[unlockQuery] === 0 && props.lock === 'Shop') {
      return (
        <div className='max-w-sm bg-gray-800 rounded-sm border border-gray-800 shadow-sm'>
          <p className='text-gray-400 text-left font-bold p-1 text-sm'>
            {props.name}
          </p>
          <div className='group bg-gray-900'>
            <img
              src={props.icon1}
              alt={`${props.name} icon`}
              title={props.name}
              className='rounded-t-lg w-24 h-20 mx-auto cursor-not-allowed hover:opacity-80 transition ease-in-out'
              data-name={props.name}
              data-sku={props.sku}
              data-icon1={props.icon1}
              data-icon2={props.icon2}
              data-cat={props.cat}
              data-type={props.type}
              onMouseOver={changeImg}
              onMouseLeave={resetImg}
            />
          </div>

          <div className='h-8 flex justify-between items-center'>
            <a
              href='#'
              className='bg-illOrange-500 text-white tracking-wide p-1 uppercase w-full hover:bg-illOrange-400 transition ease-in'
            >
              View In the Shop
            </a>
          </div>
        </div>
      );
    } else if (unlocks[unlockQuery] === 1) {
      // Basic element without unlocks checked
      return (
        <div
          className='max-w-sm bg-gray-800 rounded-sm border border-gray-800 shadow-sm'
          key={props.sku}
        >
          <p className='text-gray-300 text-left font-bold p-1 text-sm'>
            {props.name}
          </p>
          <div className='group bg-gray-900'>
            <img
              src={props.icon1}
              alt={`${props.name} icon`}
              title={props.name}
              className='rounded-t-lg w-24 h-20 mx-auto cursor-pointer hover:opacity-80 transition ease-in-out'
              data-name={props.name}
              data-sku={props.sku}
              data-icon1={props.icon1}
              data-icon2={props.icon2}
              data-cat={props.cat}
              data-type={props.type}
              onClick={handleChangeItem}
              onMouseEnter={changeImg}
              onMouseLeave={resetImg}
              // onMouseOver={changeImg}
              // onMouseLeave={resetImg}
            />
          </div>

          <div className='h-8 flex justify-between items-center'>
            <p
              className='bg-illYellow-500 text-gray-900 tracking-wide p-1 uppercase w-full hover:bg-illYellow-400 transition ease-in cursor-pointer'
              data-name={props.name}
              data-sku={props.sku}
              data-icon1={props.icon1}
              data-icon2={props.icon2}
              data-cat={props.cat}
              data-type={props.type}
              onClick={handleChangeItem}
            >
              Select
            </p>
          </div>
        </div>
      );
    } else returnNull();
  };
  return displayCard();
}
